<template>
  <div id="tac-admin-sales-report-low-price-alert">
    <router-view />
    <vue-progress-bar></vue-progress-bar>
  </div><!-- #tac-admin-sales-report-low-price-alert -->
</template>

<script>
import AuthMixin from '@/plugin/mixin/auth'

export default {
  mixins: [
    AuthMixin
  ]
}
</script>
